import React from "react";

export default class CrashDependentComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isCrashUser: props.isCrashUser };
    props.bindCrashUserChange((isCrashUser) => this.setState({ isCrashUser }));
  }

  render() {
    return this.state.isCrashUser ? this.props.children : null;
  }
}
